import {
    Button,
    FormControl,
    IconButton,
    makeStyles,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    useMediaQuery,
    useTheme,
} from "@material-ui/core"
import { Delete } from "@material-ui/icons"
import React, { useEffect, useState } from "react"
import HoraMask from "../../masks/hora"
import { alertStart } from "../../routes"
import {
    excluirTurnosAgendamento,
    getTurnosAgendamento,
    salvarTurnosAgendamento,
} from "../../services/configuracoes-estabelecimentos"
import useAppStore from "../../stores/AppStore"
import useLoadingStore from "../../stores/LoadingStore"
import Cabecalho from "../Cabecalho"

enum WeekDay {
    Domingo = "DOMINGO",
    Segunda = "SEGUNDA",
    Terca = "TERCA",
    Quarta = "QUARTA",
    Quinta = "QUINTA",
    Sexta = "SEXTA",
    Sabado = "SABADO",
}

enum TipoEntrega {
    DeliveryRetirada = 0,
    Delivery = 1,
    Retirada = 2,
}

export interface Turno {
    id: number // Somente para key
    estabelecimentoId: number
    diaSemana: WeekDay
    horaInicio: number
    horaFim: number
    tipoEntrega: TipoEntrega
}

const getWeekDay = (weekDay?: WeekDay) => {
    switch (weekDay) {
        case WeekDay.Domingo:
            return "Domingo"
        case WeekDay.Segunda:
            return "Segunda"
        case WeekDay.Terca:
            return "Terça"
        case WeekDay.Quarta:
            return "Quarta"
        case WeekDay.Quinta:
            return "Quinta"
        case WeekDay.Sexta:
            return "Sexta"
        case WeekDay.Sabado:
            return "Sábado"
        default:
            return "Domingo"
    }
}

const useStyles = makeStyles({
    main: {
        paddingInline: "1rem",
        
    },
    tableContainer: {
        marginTop: "6em",
        padding: "1em",
        display: "flex",
        flexDirection: "column",
        gap: "0.5em",
        "& td, th": { textAlign: "center" },
        "& input": { textAlign: "right" },
    },
    buttonContainer: { display: "flex", gap: "0.5rem" },
})

const getTime = (time: number) => {
    let hour = Math.floor(time / 60).toString()
    if (hour.length === 1) hour = "0" + hour

    let minute = (time % 60).toString()
    if (minute.length === 1) minute = "0" + minute

    return hour + minute
}

const getNumberOfMinutes = (time: string) => {
    const [hour, minutes] = time.split(":")

    return 60 * Number(hour) + Number(minutes)
}

let contadorNovosTurnos = -1

export default function Agendamento() {
    const classes = useStyles()
      const theme = useTheme()
    const mobile = useMediaQuery(theme.breakpoints.down("md"))


    const idEstabelecimento = useAppStore(
        s => s.configuracoes?.user?.parametros?.estabelecimento?.id
    )
    const setLoading = useLoadingStore(s => s.setLoading)

    const [turnos, setTurnos] = useState<Turno[]>([])
    const [turnosExcluidos, setTurnosExcluidos] = useState<Turno[]>([])
    const adicionarNovoTurno = () =>
        setTurnos(p => [
            ...p,
            {
                horaInicio: 0,
                horaFim: 1439,
                id: contadorNovosTurnos--,
                estabelecimentoId: idEstabelecimento!,
                tipoEntrega: 0,
                diaSemana: WeekDay.Domingo,
            },
        ])
    const excluirTurno = (t: Turno) => {
        setTurnosExcluidos(prev => [...prev, t])
        setTurnos(prev => {
            prev.splice(
                prev.findIndex(p => p.id === t.id),
                1
            )
            return [...prev]
        })
    }

    // TODO: Não permitir fim com 00:00

    useEffect(() => {
        if (idEstabelecimento) getTurnosAgendamento(idEstabelecimento).then(setTurnos)
    }, [])

    // Checar se este é o id certo (mudança de estabelecimento)
    if (!idEstabelecimento) return null

    const salvarTurnos = async () => {
        setLoading(true)

        try {
            if (turnosExcluidos.length) {
                await excluirTurnosAgendamento(turnosExcluidos, idEstabelecimento)
                setTurnosExcluidos([])
            }

            const turnosSalvos = await salvarTurnosAgendamento(turnos, idEstabelecimento)

            setTurnos(turnosSalvos)

            alertStart("Turnos atualizados com sucesso!", "success")
        } catch (error: any) {
            alertStart(error.message, "error")
            console.error(error)
        } finally {
            setLoading(false)
        }
    }

    return (
        <main className={classes.main} style={{
            marginLeft: mobile? "": "80px"
        }}>
            <Cabecalho pagina="Agendamento de Pedidos" />
            <TableContainer component={Paper} className={classes.tableContainer}>
                <div className={classes.buttonContainer}>
                    <Button
                        variant="outlined"
                        color="primary"
                        fullWidth
                        style={{ flex: 1 }}
                        onClick={adicionarNovoTurno}
                    >
                        Adicionar Turno
                    </Button>
                    <Button
                        variant="contained"
                        style={{ backgroundColor: "#28a745", color: "white", flex: "0 0 12em" }}
                        fullWidth
                        onClick={salvarTurnos}
                    >
                        Salvar
                    </Button>
                </div>

                <Table>
                    <TableHead>
                        <TableCell>Dia da Semana</TableCell>
                        <TableCell>Início</TableCell>
                        <TableCell>Fim</TableCell>
                        <TableCell>Tipo de Entrega</TableCell>
                        <TableCell></TableCell>
                    </TableHead>
                    <TableBody>
                        {turnos.map((t, index) => (
                            <TableRow key={t.id}>
                                <TableCell>
                                    <FormControl fullWidth variant="outlined">
                                        <Select
                                            variant="outlined"
                                            fullWidth
                                            value={t.diaSemana}
                                            onChange={e => {
                                                setTurnos(prev => {
                                                    prev[index].diaSemana = e.target
                                                        .value as WeekDay

                                                    return [...prev]
                                                })
                                            }}
                                        >
                                            <MenuItem value={WeekDay.Domingo}>Domingo</MenuItem>
                                            <MenuItem value={WeekDay.Segunda}>Segunda</MenuItem>
                                            <MenuItem value={WeekDay.Terca}>Terça</MenuItem>
                                            <MenuItem value={WeekDay.Quarta}>Quarta</MenuItem>
                                            <MenuItem value={WeekDay.Quinta}>Quinta</MenuItem>
                                            <MenuItem value={WeekDay.Sexta}>Sexta</MenuItem>
                                            <MenuItem value={WeekDay.Sabado}>Sábado</MenuItem>
                                        </Select>
                                    </FormControl>
                                </TableCell>
                                <TableCell>
                                    <TextField
                                        variant="outlined"
                                        defaultValue={getTime(t.horaInicio)}
                                        onChange={e => {
                                            const value = e.target.value.trim()

                                            if (value.length === 5)
                                                setTurnos(prev => {
                                                    prev[index].horaInicio =
                                                        getNumberOfMinutes(value)

                                                    return [...prev]
                                                })
                                        }}
                                        InputProps={{ inputComponent: HoraMask }}
                                    />
                                </TableCell>
                                <TableCell>
                                    <TextField
                                        variant="outlined"
                                        defaultValue={getTime(t.horaFim)}
                                        onChange={e => {
                                            let value = e.target.value.trim()

                                            if (value.length === 5) {
                                                if (value === "00:00") {
                                                    alertStart(
                                                        "Se quiser que o turno termine meia-noite, preencha com 23:59.",
                                                        "warning"
                                                    )

                                                    e.target.value = "23:59"
                                                    value = e.target.value
                                                }

                                                setTurnos(prev => {
                                                    prev[index].horaFim = getNumberOfMinutes(value)

                                                    return [...prev]
                                                })
                                            }
                                        }}
                                        InputProps={{ inputComponent: HoraMask }}
                                    />
                                </TableCell>
                                <TableCell>
                                    <FormControl fullWidth variant="outlined">
                                        <Select
                                            variant="outlined"
                                            fullWidth
                                            defaultValue={t.tipoEntrega}
                                            onChange={e => {
                                                setTurnos(prev => {
                                                    prev[index].tipoEntrega = e.target
                                                        .value as TipoEntrega

                                                    return [...prev]
                                                })
                                            }}
                                        >
                                            <MenuItem value={TipoEntrega.DeliveryRetirada}>
                                                Delivery e Retirada
                                            </MenuItem>
                                            <MenuItem value={TipoEntrega.Delivery}>
                                                Delivery
                                            </MenuItem>
                                            <MenuItem value={TipoEntrega.Retirada}>
                                                Retirada
                                            </MenuItem>
                                        </Select>
                                    </FormControl>
                                </TableCell>
                                <TableCell>
                                    <IconButton onClick={() => excluirTurno(t)}>
                                        <Delete />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </main>
    )
}
